<template>
    <div>
      <h6
        style="font-weight: 400; margin: 0px !important; padding: 0px !important"
      >
        {{ parseDate(VALUE) }}
      </h6>
    </div>
  </template>
      <script>
      import moment from "moment";
  export default {
    data() {
      return {
        VALUE: "",
      };
    },
    created() {
      this.VALUE = this.params.value;
    },
    methods:{
        parseDate(date) {
            if (typeof date == "undefined" || date == null) return "";
            if(date.includes("1900-01-01") == true) return "";
            return moment(String(date)).format("DD.MM.YYYY");
        },
    }
  };
  </script>
      